// extracted by mini-css-extract-plugin
export default {"container":"hours_container__4MnT6","text":"hours_text__tTcwu","slots":"hours_slots__si8ka","slot":"hours_slot__nmpms","active":"hours_active__Sn0I0"};